import { Skeleton } from '@/components/ui';

export function SettingsApprovedSendersSkeleton() {
  return (
    <div className="flex flex-col gap-6 px-5 py-5">
      {/* Info banner */}
      <Skeleton className="h-12 w-full rounded-md" />

      {/* Add input */}
      <div className="flex flex-col gap-2">
        <Skeleton className="h-4 w-36" />
        <div className="flex gap-2">
          <Skeleton className="h-10 flex-1 rounded-md" />
          <Skeleton className="h-10 w-16 rounded-md" />
        </div>
      </div>

      {/* Sender list */}
      <div className="flex flex-col gap-2">
        <Skeleton className="h-4 w-28" />
        <Skeleton className="h-12 w-full rounded-lg" />
        <Skeleton className="h-12 w-full rounded-lg" />
      </div>
    </div>
  );
}
